@if (isFilter()) {
  <button
    type="button"
    class="filter-trigger"
    [class.filter-trigger--active]="isOpen()"
    [class.filter-trigger--has-value]="currentDisplayItem() !== null"
    [disabled]="effectiveDisabled()"
    cdkOverlayOrigin
    #triggerOrigin="cdkOverlayOrigin"
    #triggerRef
    role="combobox"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="effectiveDisabled()"
    [attr.aria-controls]="panelId"
    [attr.aria-activedescendant]="activeOptionId()"
    aria-haspopup="listbox"
    (click)="openPanelSingleFilter()"
    (keydown)="onFilterTriggerKeydown($event)">
    <span class="filter-trigger__text">{{ currentDisplayItem() || effectiveLabel() || 'Seleccionar' }}</span>
    <svg class="filter-trigger__chevron" viewBox="0 0 24 24" fill="none">
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="cancelSingleSelection()"
    (detach)="cancelSingleSelection()"
    (positionChange)="onPositionChange($event)">
    <div
      class="options-panel options-panel--filter options-panel--single-filter"
      [class.options-panel--above]="isAbove()"
      role="listbox"
      [attr.id]="panelId"
      (keydown)="onPanelKeydown($event)">
      <div class="filter-panel-header">{{ effectiveLabel() }}</div>
      @if (!hasNoItems()) {
      <div class="multiselect-search">
        <div class="filter-search-container">
          <svg class="filter-search-icon" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M16 16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input
            class="filter-search-input"
            type="text"
            placeholder="Buscar..."
            [value]="searchTerm()"
            (input)="onSearchChange($any($event.target).value)"
            (keydown)="onSearchKeydown($event)">
        </div>
      </div>
      }
      @if (hasNoItems() || hasNoSearchResults()) {
        <div class="options-empty" role="status">
          {{ hasNoItems() ? emptyMessage() : noResultsMessage() + ': ' + searchTerm() }}
        </div>
      }
      <div class="options-scroll">
        @for (row of filteredRenderRows(); track trackByRow($index, row)) {
          @if (row.rowType === 'header') {
            <div class="group-label">{{ row.label }}</div>
          } @else {
            <div
              class="option-item option-item--single-filter"
              role="option"
              [attr.id]="getOptionId(row.flatIndex)"
              [attr.aria-selected]="isTempSingleSelected(row.item!.key)"
              [class.active]="isActiveOptionRow(row)"
              [class.disabled]="isOptionRowDisabled(row)"
              tabindex="-1"
              (click)="selectTempSingleItem(row)">
              <div class="multiselect-checkbox" [class.checked]="isTempSingleSelected(row.item!.key)">
                @if (isTempSingleSelected(row.item!.key)) {
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                }
              </div>
              <span [title]="row.item?.display ?? row.item?.value ?? ''">{{ row.item?.display ?? row.item?.value }}</span>
            </div>
          }
        }
      </div>
      <div class="multiselect-actions">
        <button type="button" class="multiselect-btn multiselect-btn--cancel" (click)="cancelSingleSelection()">Cancelar</button>
        <button type="button" class="multiselect-btn multiselect-btn--apply" (click)="applySingleSelection()">Aplicar</button>
      </div>
    </div>
  </ng-template>
} @else {
  <div class="select__form" [class.select__form--horizontal]="display() === 'horizontal'">
    @if (effectiveLabel() && display() !== 'horizontal') {
      <label class="select-label" [style]="labelStyle()">
        {{ effectiveLabel() }}
        @if (effectiveRequired()) {
          <span class="required-mark">*</span>
        }
      </label>
    }

    @if (effectiveLabel() && display() === 'horizontal') {
      <label class="inline-label" [style]="labelStyle()">
        {{ effectiveLabel() }}
        @if (effectiveRequired()) {
          <span class="required-mark">*</span>
        }
      </label>
    }

    <div class="select-container">
      <div
        class="select-trigger custom-reactive-select-arrow"
        [class.disabled]="effectiveDisabled()"
        [class.open]="isOpen()"
        [style]="customStyle()"
        [style.--so-select-height.px]="selectHeight()"
        cdkOverlayOrigin
        #triggerOrigin="cdkOverlayOrigin"
        #triggerRef
        role="combobox"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-disabled]="effectiveDisabled()"
        [attr.aria-controls]="panelId"
        [attr.aria-activedescendant]="activeOptionId()"
        [attr.tabindex]="effectiveDisabled() ? -1 : 0"
        aria-haspopup="listbox"
        [title]="effectiveDisabled() && tooltipDisabledText() ? tooltipDisabledText() : ''"
        (click)="onTriggerClick()"
        (keydown)="onTriggerKeydown($event)">
        @if (!currentDisplayItem()) {
          <span class="placeholder">{{ placeholder() }}</span>
        }
        @if (currentDisplayItem()) {
          <span class="selected-value text-truncate">{{ currentDisplayItem() }}</span>
        }
      </div>

      @if (currentDisplayItem() !== null && displayValueStyle()) {
        <span [class]="'display-value text-truncate ' + displayValueClass()" [style]="displayValueStyle()">
          {{ currentDisplayItem() }}
        </span>
      }

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="triggerOrigin"
        [cdkConnectedOverlayOpen]="isOpen()"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayFlexibleDimensions]="true"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        (backdropClick)="closePanel()"
        (detach)="closePanel()"
        (positionChange)="onPositionChange($event)">
        <div
          class="options-panel"
          [class.options-panel--above]="isAbove()"
          role="listbox"
          [attr.id]="panelId"
          [style.width.px]="triggerWidth() || null"
          (keydown)="onPanelKeydown($event)">
          @if (hasNoItems()) {
            <div class="options-empty" role="status">{{ emptyMessage() }}</div>
          }
          <div class="options-scroll">
            @for (row of renderRows(); track trackByRow($index, row)) {
              @if (row.rowType === 'header') {
                <div class="group-label">{{ row.label }}</div>
              } @else {
                <div
                  class="option-item"
                  role="option"
                  [attr.id]="getOptionId(row.flatIndex)"
                  [attr.aria-selected]="isOptionRowSelected(row)"
                  [class.selected]="isOptionRowSelected(row)"
                  [class.active]="isActiveOptionRow(row)"
                  [class.disabled]="isOptionRowDisabled(row)"
                  (click)="selectRow(row)">
                  {{ row.item?.display ?? row.item?.value }}
                </div>
              }
            }
          </div>
        </div>
      </ng-template>

      @if (effectiveLoading()) {
        <div class="spinner"></div>
      }
    </div>
  </div>
}
